exports.airportCodes = (param) => {
  switch (param) {
    case 'Aberdeen':
      return 'ABZ'
    case 'Belfast City (George Best)':
      return 'BHD'
    case 'Belfast International':
      return 'BFS'
    case 'Birmingham':
      return 'BHX'
    case 'Bournemouth':
      return 'BOH'
    case 'Bristol':
      return 'BRS'
    case 'Cardiff':
      return 'CWL'
    case 'Doncaster-Sheffield (Robin Hood)':
      return 'DSA'
    case 'Dublin':
      return 'DUB'
    case 'Durham Tees Valley':
      return 'MME'
    case 'East Midlands':
      return 'EMA'
    case 'Edinburgh':
      return 'EDI'
    case 'Exeter':
      return 'EXT'
    case 'Gatwick':
      return 'LGW'
    case 'Glasgow International':
      return 'GLA'
    case 'Glasgow Prestwick':
      return 'PIK'
    case 'Heathrow':
      return 'LHR'
    case 'Humberside':
      return 'HUY'
    case 'Inverness':
      return 'INV'
    case 'Leeds Bradford':
      return 'LBA'
    case 'Liverpool':
      return 'LPL'
    case 'London City':
      return 'LCY'
    case 'Luton':
      return 'LTN'
    case 'Manchester':
      return 'MAN'
    case 'Newcastle':
      return 'NCL'
    case 'Norwich':
      return 'NWI'
    case 'Shannon':
      return 'SNN'
    case 'Southampton':
      return 'SOU'
    case 'Southend':
      return 'SEN'
    case 'Stansted':
      return 'STN'
    case 'Dover Port':
      return 'DOV'
    case 'Southampton Port':
      return 'SOP'
    default:
      return 'LGW'
  }
}
